module.exports = __webpack_public_path__ + "static/media/form-graphic.acbb103f.png";